import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
	name: 'user',
	slice: 'user',
	initialState: {
		loggedIn: false,
		id: null,
		name: '',
		email: '',
		myDesigns: []
	},
	reducers: {
		logIn(state, action) {
			state.loggedIn = true;
			state.id = action.payload.id;
			state.name = action.payload.name;
			state.email = action.payload.email;
		},
		logOut(state, action) {
			state.loggedIn = false;
			state.id = null;
			state.name = '';
			state.email = '';
			state.myDesigns = [];
			state.myDesignsFiltered = [];
		},
		setMyDesigns(state, action) {
			state.myDesigns = action.payload;
		},
		updateMyDesignInTable(state, action) {
			const myDesignIndex = state.myDesigns.findIndex(md => md.id === action.payload.id);

			if (myDesignIndex > -1) {
				state.myDesigns[myDesignIndex] = action.payload;
			} else {
				state.myDesigns.push(action.payload);
			}
		},
		updateMyDesignName(state, action) {
			state.myDesigns.find(myDesign => myDesign.id === action.payload.id).name = action.payload.name;
			state.myDesigns.find(myDesign => myDesign.id === action.payload.id).dateModified = action.payload.dateModified;
		},
		setFavorite(state, action) {
			state.myDesigns.find(myDesign => myDesign.id === action.payload.id).favorite = action.payload.favorite;
		},
		deleteMyDesign(state, action) {
			state.myDesigns.splice(
				state.myDesigns.findIndex(myDesign => myDesign.id === action.payload),
				1
			);
		}
	}
});

export default userSlice;
